import React, { FC, MouseEvent } from "react";
import { joinClassNames as c } from "Shared/util/styles";
import styles from "./radio-group.css";

export type RadioGroupOption = {
    label: string;
    value: string;
};

type RadioGroupProps = {
    className?: string;
    disabled?: boolean;
    onChange?: (value: RadioGroupOption["value"]) => void;
    options: RadioGroupOption[];
    selectedOption?: RadioGroupOption["value"];
    small?: boolean;
};

export const RadioGroup: FC<RadioGroupProps> = ({
    className,
    disabled,
    onChange,
    options,
    selectedOption,
    small = false,
}) => {
    const handleChange = (event?: MouseEvent<HTMLDivElement>) => {
        if (disabled || !onChange) return;

        const { value } = event?.currentTarget?.dataset || {};
        if (value === undefined || value === selectedOption) return;

        onChange(value);
    };

    return (
        <div
            className={c(
                styles.container,
                disabled && styles.disabled,
                className,
            )}
        >
            {options.map(({ label, value }) => (
                <div
                    className={styles.radioContainer}
                    data-value={value}
                    key={value}
                    onClick={handleChange}
                >
                    <div
                        className={c(
                            styles.outerCircle,
                            value === selectedOption && styles.selected,
                            small && styles.small,
                        )}
                    >
                        <div
                            className={c(
                                styles.innerCircle,
                                value === selectedOption && styles.selected,
                                small && styles.small,
                            )}
                        />
                    </div>
                    <div className={styles.label}>{label}</div>
                </div>
            ))}
        </div>
    );
};
